module.exports = __webpack_public_path__ + "img/area_3.32ad427e.png";